import { actionsWithFirstPriority } from '@constants'
import { ActionRow } from '@types'

export const assignPriorityAndSortActions = (actions: ActionRow[]) => {
  const prioritizedActions = actions.map(action => {
    return {
      ...action,
      priorityExecute:
        action.actionCode && actionsWithFirstPriority.includes(action.actionCode) ? 1 : 2,
    }
  })

  return prioritizedActions.sort((a, b) => a.priorityExecute - b.priorityExecute)
}
